import { transitionTime } from "./index.styled";

export const collapseColorClassWithIndex = (
  index: number,
  children?: number,
) => {
  if (index > 6) index -= 6;
  let className = `Collapse-Color-${index}`;
  if (children === 0) className += " Collapse-Empty";

  return className;
};

export const toggleCollapse = (target: HTMLElement, status?: boolean) => {
  const collapse = target.closest(".Collapse") as HTMLElement;
  if (status !== undefined) {
    if (!status) {
      collapse.classList.remove("Collapsed");
    } else {
      collapse.classList.add("Collapsed");
    }
    return;
  }
  collapse.classList.toggle("Collapsed");
};

export const toggleCollapseHandler = (event, status?: boolean) => {
  event.stopPropagation();
  const target = event.target as HTMLElement;
  const collapse = target.closest(".Collapse");
  const header = target.closest(".Collapse-Header");

  if (!!collapse && !!header) {
    toggleCollapse(target, status);
  }
};

export const collapseBorderResizer = ({ borderRef, bodyRef }) => {
  if (borderRef.current && bodyRef.current) {
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement)?.getPropertyValue(
        "--Collapse-Header-Height",
      ) || "50",
    );
    const totalChild = bodyRef.current?.children?.length;
    const lastChild = bodyRef.current?.children[totalChild - 1];
    const lastChildBodyHeight =
      lastChild?.querySelector(".Collapse-Body")?.clientHeight || 0;
    const bottomBorderHeight = lastChildBodyHeight + headerHeight / 2 + 5;

    borderRef.current.style.bottom = `${bottomBorderHeight}px`;
  }
};

export const Observer = ({ borderRef, bodyRef }) => {
  return new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.attributeName === "class") {
        setTimeout(() => {
          collapseBorderResizer({ borderRef, bodyRef });
        }, transitionTime / 2);
        setTimeout(() => {
          collapseBorderResizer({ borderRef, bodyRef });
        }, transitionTime);
      }
    }
  });
};

export const onClickListener = (event: Event) => {
  document.querySelectorAll(".Collapse-Header").forEach((el) => {
    el.classList.remove("Active");
  });

  const target = event.target as HTMLElement;
  const header = target.closest(".Collapse-Header");

  if (header) {
    header.classList.add("Active");
  }
};
